import { Navigate, useLocation } from "react-router-dom";
import { useUserProfile } from "../context/user/useProfileProfile.js";
import { useNBCUSDK } from "../context/sdk/useSDK";
// import LoadingScreen from "./LoadingScreen";
import { ROUTES } from "../routes/routeConstants";

const ProtectedRoute = ({ children }) => {
  const { userProfile } = useUserProfile();
  const { sdkReady } = useNBCUSDK();
  const location = useLocation();

  // Show loading screen while SDK is initializing
  // if (!sdkReady) {
  //   return <LoadingScreen />;
  // }

  // If not logged in, redirect to LandingPage
  if (!userProfile.isLoggedIn) {
    return <Navigate to={ROUTES.ROOT} replace state={{ from: location }} />;
  }

  // If logged in and onboarding is complete, allow access
  return children;
}


export default ProtectedRoute;

